var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A1227;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -981 -457 )"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M994,465.4c0.1,0.1,0.1,0.3,0.1,0.4c-0.1,0.2-0.2,0.2-0.4,0.2h-2.3v4.1c0,0.1,0,0.2-0.1,0.3s-0.2,0.1-0.3,0.1 h-2.3c-0.1,0-0.2,0-0.3-0.1s-0.1-0.2-0.1-0.3V466h-2.3c-0.1,0-0.2,0-0.3-0.1s-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3l3.7-3.7 c0.1-0.1,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1L994,465.4z M993.2,460.5c-1-0.6-2-0.9-3.2-0.9s-2.2,0.3-3.2,0.9s-1.8,1.3-2.3,2.3 s-0.9,2-0.9,3.2s0.3,2.2,0.9,3.2s1.3,1.8,2.3,2.3s2,0.9,3.2,0.9s2.2-0.3,3.2-0.9s1.8-1.3,2.3-2.3s0.9-2,0.9-3.2s-0.3-2.2-0.9-3.2 S994.2,461.1,993.2,460.5z M997.8,461.5c0.8,1.4,1.2,2.9,1.2,4.5s-0.4,3.1-1.2,4.5s-1.9,2.5-3.3,3.3s-2.9,1.2-4.5,1.2 s-3.1-0.4-4.5-1.2s-2.5-1.9-3.3-3.3s-1.2-2.9-1.2-4.5s0.4-3.1,1.2-4.5s1.9-2.5,3.3-3.3s2.9-1.2,4.5-1.2s3.1,0.4,4.5,1.2 S997,460.1,997.8,461.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.6b13b00fcd2a74df53f3b1572241457f.svg";
export { ForwardRef as ReactComponent };